module.exports = __webpack_public_path__ + "static/media/debating.d447b20a.jpg";